import { render, staticRenderFns } from "./UpscalesButton.vue?vue&type=template&id=3d830e89&scoped=true"
import script from "./UpscalesButton.vue?vue&type=script&lang=js"
export * from "./UpscalesButton.vue?vue&type=script&lang=js"
import style0 from "./UpscalesButton.vue?vue&type=style&index=0&id=3d830e89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d830e89",
  null
  
)

export default component.exports